<template>
  <div>
    <v-card v-if="Loading" color="yellow lighten-2">
      <v-card-text>
        <h3>Cargando</h3>
        <h3>Por Favor Espere...</h3>
      </v-card-text>
      <v-overlay>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
    <v-row dense v-if="!Loading">
      <v-col md="3">
        <v-text-field
          class="pl-3"
          :filled="readonly"
          :readonly="readonly"
          style="max-width: 220px;"
          type="date"
          dense
          hide-details
          outlined
          label="Fecha"
          v-model="selected.fecha"
        >
        </v-text-field>
      </v-col>
      <v-col md="1">
        <v-text-field
          :readonly="readonly"
          :filled="readonly"
          dense
          hide-details
          outlined
          label="Dias"
          v-model="selected.cantidadDias"
          v-mask="'##'"
        >
        </v-text-field>
      </v-col>
      <v-col md="3">
        <cboSector :readonly="readonly" v-model="selected.id_sector">
        </cboSector>
      </v-col>
      <v-col md="3">
        <v-select
          class="ml-2"
          v-model.number="selected.estado"
          :value="selected.estado"
          :readonly="!evalua"
          :items="estados"
          item-text="descripcion_estado"
          item-value="id_estado"
          label="Estado"
          :return-object="false"
          hide-selected
          hide-details
          outlined
          dense
          style="max-width: 150px"
        >
        </v-select>
      </v-col>
      <v-col md="1">
        <v-btn
          icon
          @click="Guardar()"
          v-if="!readonly && alta"
          :disabled="!enabledGuardar"
          outlined
          color="teal"
        >
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
      </v-col>
      <v-col md="1">
        <v-btn
          icon
          @click="Eliminar()"
          v-if="!readonly && !alta"
          outlined
          color="red"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mask } from "vue-the-mask";
import cboSector from "@/components/Sectores/Combo";
export default {
  directives: { mask },
  props: {
    id_solic: Number,
    id: {
      type: Number,
      default: 0,
    },
    prorroga: {
      type: Object,
      default: null,
    },
    value: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    evalua: {
      type: Boolean,
      default: false,
    },
    alta: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    cboSector,
  },
  data() {
    return {
      selected: {},
      inicial: {},
      Loading: false,
      estados: [
        { id_estado: 1, descripcion_estado: "Pendiente" },
        { id_estado: 2, descripcion_estado: "Autorizado" },
        { id_estado: 3, descripcion_estado: "En Gestion" },
        { id_estado: 4, descripcion_estado: "Rechazado" },
      ],
    };
  },
  computed: {
    enabledGuardar() {
      let ret = true;
      if (
        !this.selected.fecha ||
        !this.selected.cantidadDias ||
        this.selected.cantidadDias < 1 ||
        !this.selected.id_sector
      ) {
        ret = false;
      }
      if (
        this.selected.fecha == this.inicial.fecha &&
        this.selected.cantidadDias == this.inicial.cantidadDias &&
        this.selected.id_sector == this.inicial.id_sector &&
        this.selected.estado == this.inicial.estado
      ) {
        ret = false;
      }
      return ret;
    },
  },
  methods: {
    ...mapActions("prorrogas", ["guardarEntidad"]),
    resetear() {
      if (this.prorroga == null) {
        this.selected = {
          Id: this.id,
          id_solic: this.id_solic,
          id_sector: 0,
          cantidadDias: 1,
          fecha: "",
          estado: 1,
        };
      } else {
        this.selected = { ...this.prorroga };
      }
      this.inicial = { ...this.selected };
    },
    async Guardar() {
      this.Loading = true;
      let avisar = false;
      if (this.selected.Id == 0) {
        avisar = true;
      }
      //this.selected = await this.guardarEntidad(this.selected);
      this.inicial = { ...this.selected };
      if (avisar) {
        this.$emit("prorrogadadaalta", this.selected);
        this.resetear();
      }
      this.Loading = false;
    },
    async Eliminar() {
      this.Loading = true;
      //this.inicial = { ...this.selected };
      this.$emit("prorrogaeliminada", this.selected);
      //this.resetear();
      this.Loading = false;
    },
  },
  mounted() {
    this.resetear();
  },
  watch: {
    id_solic() {
      this.resetear();
    },
    prorroga() {
      this.resetear();
    },
    selected: {
      handler: function(val, oldVal) {
        this.$emit("updated", this.selected);
      },
      deep: true,
    },
  },
};
</script>

<style></style>
